import React from 'react';

import {
  MenuButton,
  MenuItem,
  Menu,
  MenuList,
  MenuTrigger,
  MenuPopover,
  makeStyles,
  shorthands,
} from '@fluentui/react-components';
import { CSMLAdType } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

const adTypeList = [CSMLAdType.PMax, CSMLAdType.MMA, CSMLAdType.Audience, CSMLAdType.ImageExtension];
const adTypeStrings = {
  [CSMLAdType.PMax]: _TL_('Performance Max'),
  [CSMLAdType.MMA]: _TL_('Multimedia ads'),
  [CSMLAdType.Audience]: _TL_('Audience ads'),
  [CSMLAdType.ImageExtension]: _TL_('Image extensions'),
};

const useStyles = makeStyles({
  button: {
    '&.fui-Button': {
      ...shorthands.border('none'),
    },
  },
});


export const AdTypeControl = ({ adType, onChange, i18n }) => {
  const classes = useStyles();

  return (
    <Menu>
      <MenuTrigger>
        <MenuButton className={classes.button}>{i18n.getString(adTypeStrings[adType])}</MenuButton>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {
            adTypeList.map(type => (
              <MenuItem
                key={type}
                onClick={() => onChange(type)}
              >
                {i18n.getString(adTypeStrings[type])}
              </MenuItem>
            ))
          }
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
